module.exports = __webpack_public_path__ + "img/timor-leste.24586ca1.svg";